<template>
	<div class="tree-section-container h-100">
		<div>
			<el-tree :data="menuTree" :default-expanded-keys="[0]" @node-click="handleNodeClick"></el-tree>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/MenuManagement/store/helpers';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setTreeList() {
			this.$sf_toggleLoading(true);
			this.getScreens_({ plantCd: this.user.plantCd, langCd: this.user.langCd })
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		handleNodeClick(data) {
			// console.log('@@@@ click')
			this.setSelectedMenu_(data);
			this.setSearchParam_({ key: 'parentScrId', value: data.scrId });
			this.$emit('Refresh');
		}
	},
	created() {
		this.getPlants_().then(this.setTreeList);
	}
};
</script>

<style>
.tree-section-container {
	width: 20%;
	display: flex;
	flex-direction: column;
	background-color: #ffffff;
	overflow-y: scroll;

	border-right: none;
	border-bottom: none;
	border-radius: 5px;
	border: 1px solid #8da1b9;
}
</style>
